export type ApiErrorPayload = {
  statusCode?: number;
  message?: string | string[];
  [key: string]: unknown;
};

export class ShiftAuthRequestError extends Error {
  status: number;
  isNetworkError: boolean;
  payload: ApiErrorPayload | null;

  constructor(
    message: string,
    status: number,
    isNetworkError: boolean,
    payload: ApiErrorPayload | null = null,
  ) {
    super(message);
    this.name = 'ShiftAuthRequestError';
    this.status = status;
    this.isNetworkError = isNetworkError;
    this.payload = payload;
  }
}
